<template>
    <transition name="slide-fade">
        <div class="pdpa-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="relative">
                    <img src="../../../../assets/bg-head.png" />
                    <img class="absolute m-auto top-0 left-0 right-0 w-20" src="../../../../assets/icon-tipcoin.png" />
                </div>
                 <!-- min-h-81vh -->
                <div class="bg-white rounded-25">
                    <!-- h-67vh -->
                    <PdpaContent class="p-5 overflow-auto min-h-66vh"
                        :type="type"
                        :title="title"
                        :localeCode="localeCode"
                        :v-model:version="version"
                        @onError="onError($event)" />

                    <div class="py-3">

                        <div @click="onOk()" class="text-white bg-1c3e95 w-4/5 text-center m-auto p-2 rounded-3xl shadow-btn">{{btnOk}}</div>
                        <div class="text-center">
                            <img class="w-44 m-auto pt-3" src="../../../../assets/poer-tip.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <!-- <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition> -->
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
// import PrimaryButton from '@/components/Button/PrimaryButton.vue';
// import SecondaryButton from '@/components/Button/SecondaryButton.vue';
export default {
    name: 'PdpaModal',
    mixins: [LocaleMixin],
    components: {
        PdpaContent,
        // SecondaryButton
    },
    props: {
        controller: { type: Object }
    },
    data: function () {
        return {
            open: false,

            title: '',
            type: '',
            version: '',
            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        //#region event
        onOk: function () {
            this.hide();
            this.controller.sendCallbackOk(this.version);
        },
        onCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        onError: function (err) {
            this.hide();
            this.controller.alertModal
                .clearModal()
                .setMsg(err.message)
                .show();
        },
        //#endregion event
        show: function (config) {
            this.title = config.title;
            this.type = config.type || 'terms';
            this.btnOk = config.btnOk;
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        }
    }
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

    .pdpa-modal {
        @extend %modal;

        .modal-content {
            width: 100%;
            height: 100vh;
            border-radius: 20px;
            background-image: linear-gradient(to bottom, #1c3e95 2%, #1c3d91 2%, #1a326e 16%);
            // overflow: hidden;

            @include mobile {
                width: 100%;
                padding: 10px;
            }
        }
    }
</style>
